import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const paymentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createCustomer: builder.mutation({
      query: ({stripeToken = null, customer_id = null, is_stax = false}) => ({
        url: 'customer/',
        method: 'POST',
        body: {stripe_token: stripeToken, is_stax, customer_id},
      }),
      invalidatesTags: ['Customer', 'Patient'],
    }),
    getCards: builder.query({
      query: ({} = {}) => ({
        url: '/customer',
        method: 'GET',
      }),
      providesTags: ['Customer'],
    }),
    updateCard: builder.mutation({
      query: ({
        id, // payment method id 
        stripe_token = null, 
        customer_id = null, 
        is_stax = false,
        is_default = null,
      }) => ({
        url: `customer/${id ? (id + '/') : ''}`,
        method: 'PUT',
        body: is_default ? {is_default: true} : {stripe_token, customer_id, is_stax},
      }),
      invalidatesTags: ['Customer'],
    }),
    removeCard: builder.mutation({
      query: ({id}) => ({
        url: `customer/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Customer'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateCustomerMutation,
  useGetCardsQuery,
  useUpdateCardMutation,
  useRemoveCardMutation,
} = paymentApi;
